export default {
  header: 'Ingrediënten',
  total: 'Totaal',
};
